export default __webpack_public_path__ + "static/media/stereo_02.9b18e90e.gif";